import * as React from 'react';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { Col, Row } from 'antd';

interface INoAccessProps extends RouteComponentProps {
  domain: string;
  deliveryMethodId?: string;
}

class NoAccessPage extends React.Component<INoAccessProps> {

  public render() {
    return (
      <Row>
        <Col span={24} style={{ background: 'transparent', padding: '15% 0' }}>
          <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <h2
                style={{
                  fontSize: '150pt',
                  lineHeight: '200px',
                  fontWeight: 'bold',
                  padding: '0',
                  margin: '0',
                  color: '#DDD'
                }}
              >
                403
              </h2>
              <h4 style={{ padding: '0', margin: '0', fontSize: '23px', fontWeight: 'bold', textTransform: 'uppercase' }}>Forbidden</h4>
              <div style={{ marginBottom: '20px', textTransform: 'uppercase' }}>Access to this resource on the server is denied!</div>
              <Link to={`/${this.props.domain}/application/dashboard`} className="ant-btn ant-btn-primary">Back to home</Link>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default withRouter(NoAccessPage);



// WEBPACK FOOTER //
// ./src/scenes/NoAccess/NoAccess.tsx